import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { messages } from './messages';
import styles from './inventory-sync-warehouse-dropdown.module.css';

const defaultlabelFormatter = (label) => label;

const InventorySyncWarehouseDropdown = ({
  toggleLabel,
  items,
  labelFormatter = defaultlabelFormatter,
  loading,
  onItemClicked,
  selectedItem,
  disabled,
}) => {
  return (
    <DropdownMenu
      className={styles['inventory-dropdown']}
      disabled={loading || disabled}
      dropdownMenuShouldHaveWidthOfButton
      variant='form'
    >
      <DropdownMenuToggler>{toggleLabel}</DropdownMenuToggler>
      {loading && (
        <DropdownMenuItem>
          <FormattedMessage {...messages.loadingWarehousesLabel} />
        </DropdownMenuItem>
      )}
      {items?.map((source) => (
        <DropdownMenuItem key={source.key} onClick={() => onItemClicked(source)} selected={selectedItem === source.key}>
          {labelFormatter(source.text)}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

InventorySyncWarehouseDropdown.propTypes = {
  toggleLabel: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
    }),
  ).isRequired,
  onItemClicked: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  labelFormatter: PropTypes.func,
  disabled: PropTypes.bool,
};

export default InventorySyncWarehouseDropdown;
